import { Typography } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import React from 'react';
import VoxelAlert from '../../../components/voxel/Alert/VoxelAlert';

export interface NotEnoughDataProps {}

export const NotEnoughData: React.FC<NotEnoughDataProps> = ({}) => {
  return (
    <div data-screenshot-id="chart-loaded">
      <VoxelAlert severity="warning" title="Project site required">
        To view this chart you first need to add a ranking site at{' '}
        <Typography variant="subtitle2" color="inherit" display="inline">
          Manage {'->'} Ranks & Sites {'->'} Ranking site
        </Typography>
      </VoxelAlert>
    </div>
  );
};

export default NotEnoughData;
